import React, { useState, useEffect } from "react";
import { meiliSearchAPI } from "../../services/api/meilisearch";
import { tenantAPI } from "../../services/api/tenant";
import { getCookie } from "../../utils/common";

const GoogleTagManager = () => {
  const [tagManagerId, setTagManagerId] = useState(null);
  const tenantUuid = getCookie("current_tenant_uuid");

  useEffect(() => {
    if (tenantUuid) {
      getTenant(tenantUuid);
    }
  }, []);

  const getTenant = (tenantUuid: string) => {
    tenantAPI?.()
      .getSingle?.(tenantUuid)
      .then((resp) => {
        if (resp.google_tag_manager_id) {
          setTagManagerId(resp.google_tag_manager_id);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${tagManagerId}`;
    script.async = true;

    document.head.appendChild(script);

    const configScript = document.createElement("script");
    configScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${tagManagerId}');
        `;

    document.head.appendChild(configScript);
  }, [tagManagerId]);

  return <></>;
};

export default GoogleTagManager;
